import { Button, Modal, TextInput, Tile } from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import { bulkDeleteCategory, createCategory, fetchAllCategory, updateCategory } from "../../redux/actions/categoryAction";

function SubscriptionsPage({ dataTableList, isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const headers = [
    {
      key: 'periode',
      header: 'Periode',
    },
    {
      key: 'price',
      header: 'Price',
    },
    {
      key: 'feature',
      header: 'Feature',
    },
    {
      key: 'hideline',
      header: 'Hideline',
    },
  ]

  const [paginationContent, setPaginationContent] = useState({
    query: '',
    page: 1,
    limit: 3,
    total: 0,
    totalItems: 0
  })

  const [modalContent, setModalContent] = useState({
    modalHeading: '',
    isOpen: false,
    categoryId: undefined,
    categoryName: undefined
  })

  const updateCategoryDetail = () => {
    dispatch(updateCategory({
      categoryId: modalContent.categoryId,
      categoryName: modalContent.categoryName
    }, () => {
      // reset modal content
      setModalContent({
        modalHeading: '',
        isOpen: false,
        categoryId: undefined,
        categoryName: undefined
      })

      dispatch(fetchAllCategory({ query: "", page: 1, limit: paginationContent.limit }, ({ totalFiltered, total }) => setPaginationContent(v => ({
        ...v,
        skip: totalFiltered,
        total,
        totalItems: PageHelper.getTotalItems(total, paginationContent.limit),
        page: 1,
        query: ""
      }))))
    }))
  }

  const bulkDelete = async (_items) => {
    dispatch(bulkDeleteCategory({
      categoryIds: _items.map((v) => ({
        _id: v.id
      }))
    }, () => {
      dispatch(fetchAllCategory({ query: "", page: 1, limit: paginationContent.limit }, ({ totalFiltered, total }) => setPaginationContent(v => ({
        ...v,
        skip: totalFiltered,
        total,
        totalItems: PageHelper.getTotalItems(total, paginationContent.limit),
        page: 1,
        query: ""
      }))))
    }))
  }

  const viewCategoryDetail = (_data) => {
    const categoryId = _data[0].id.split(":")[0]
    const categoryName = _data.filter(v => v.info.header === 'categoryName')[0]?.value

    setModalContent(v => ({
      isOpen: true,
      modalHeading: `${categoryName}`,
      categoryId,
      categoryName
    }))
  }

  const paginationChange = async (_newPage) => dispatch(fetchAllCategory({ query: paginationContent.query, page: _newPage + 1, limit: paginationContent.limit }, ({ totalFiltered, total }) => setPaginationContent(v => ({
    ...v,
    page: _newPage + 1,
    skip: totalFiltered,
    total,
    totalItems: PageHelper.getTotalItems(total, paginationContent.limit)
  }))))


  const searchTable = async (e) => {
    const { value } = e.target
    dispatch(fetchAllCategory({ query: value, page: 1, limit: paginationContent.limit }, ({ totalFiltered, total }) => setPaginationContent(v => ({
      ...v,
      query: value,
      page: 1,
      skip: totalFiltered,
      total,
      totalItems: PageHelper.getTotalItems(value.length > 0 ? totalFiltered : total, paginationContent.limit)
    }))))
  }

  useEffect(() => {
    dispatch(fetchAllCategory({ query: paginationContent.query, page: paginationContent.page, limit: paginationContent.limit }, ({ totalFiltered, total }) => setPaginationContent(v => ({
      ...v,
      skip: totalFiltered,
      total,
      totalItems: PageHelper.getTotalItems(total, paginationContent.limit)
    }))))
  }, [])

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: '/' },
      { name: 'Subscriptions' }
    ]}>
      <UIShellPagination
        dataTableList={dataTableList}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push('/subscriptions/form')}
        viewDetail={viewCategoryDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
        title="Subscription List"
        description="All Subscription Description"
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Subscription details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateCategoryDetail()}
        onRequestClose={() => setModalContent(v => ({ ...v, isOpen: false }))}>

        <p style={{ marginBottom: '1rem' }}>
          Category can be nested up to 3 levels
        </p>

        <TextInput
          data-modal-primary-focus
          labelText="Subscription Name"
          placeholder="e.g. github.com"
          value={modalContent.categoryName}
          onChange={(_v) => setModalContent(v => ({ ...v, categoryName: _v.target.value }))}
          style={{ marginBottom: '1rem' }}
        />
      </Modal>

    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    dataTableList: state.categoryReducer.dataTableList,
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(SubscriptionsPage)

